import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { StateService } from "@uirouter/angular";
import { MatDialog } from '@angular/material/dialog';
import { CrewErrorDialog } from './crew-error-dialog.component';

@Injectable()
export class CrewErrorHandler implements ErrorHandler {

    constructor(private $injector: Injector) {}

    handleError(error) {
        const messageMaxLength = 80;
        let errorMessage: string = error.message ? error.message : "Unhandled error";
        if (errorMessage.length > messageMaxLength) {
            errorMessage = errorMessage.substring(0, messageMaxLength) + "...";
        }

        const dialogRef = this.$injector.get(MatDialog).open(CrewErrorDialog);
        dialogRef.componentInstance.title = "An unhandled error occurred";
        dialogRef.componentInstance.contentStart = errorMessage;
        dialogRef.componentInstance.mainContent = error.longStack || error.stack ? error.longStack || error.stack : error;

        dialogRef.afterClosed().subscribe(() => this.$injector.get(StateService).go("app.home"));
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/crew-error-handler.ts